// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/conversation_enums.proto (package qliq_protobuf, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum qliq_protobuf.ConversationStatus
 */
export enum ConversationStatus {
  /**
   * @generated from enum value: UNASSIGNED = 0;
   */
  UNASSIGNED = 0,

  /**
   * @generated from enum value: OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: CLOSE = 2;
   */
  CLOSE = 2,

  /**
   * @generated from enum value: SPAM = 3;
   */
  SPAM = 3,

  /**
   * @generated from enum value: DUPLICATE = 4;
   */
  DUPLICATE = 4,

  /**
   * @generated from enum value: ESCALATED = 5;
   */
  ESCALATED = 5,

  /**
   * @generated from enum value: ASSIGNED_TO_BOT = 6;
   */
  ASSIGNED_TO_BOT = 6,

  /**
   * @generated from enum value: INVITED = 7;
   */
  INVITED = 7,

  /**
   * @generated from enum value: ARCHIVED = 8;
   */
  ARCHIVED = 8,

  /**
   * @generated from enum value: CANCELED = 9;
   */
  CANCELED = 9,

  /**
   * @generated from enum value: NO_REPLY = 10;
   */
  NO_REPLY = 10,
}
// Retrieve enum metadata with: proto3.getEnumType(ConversationStatus)
proto3.util.setEnumType(ConversationStatus, "qliq_protobuf.ConversationStatus", [
  { no: 0, name: "UNASSIGNED" },
  { no: 1, name: "OPEN" },
  { no: 2, name: "CLOSE" },
  { no: 3, name: "SPAM" },
  { no: 4, name: "DUPLICATE" },
  { no: 5, name: "ESCALATED" },
  { no: 6, name: "ASSIGNED_TO_BOT" },
  { no: 7, name: "INVITED" },
  { no: 8, name: "ARCHIVED" },
  { no: 9, name: "CANCELED" },
  { no: 10, name: "NO_REPLY" },
]);

/**
 * @generated from enum qliq_protobuf.ConversationTacStatus
 */
export enum ConversationTacStatus {
  /**
   * @generated from enum value: TAC_STATUS_UNDEFINED = 0;
   */
  TAC_STATUS_UNDEFINED = 0,

  /**
   * @generated from enum value: TAC_STATUS_PRESENTED = 1;
   */
  TAC_STATUS_PRESENTED = 1,

  /**
   * @generated from enum value: TAC_STATUS_NOT_APPLICABLE = 2;
   */
  TAC_STATUS_NOT_APPLICABLE = 2,

  /**
   * @generated from enum value: TAC_STATUS_ACCEPTED = 3;
   */
  TAC_STATUS_ACCEPTED = 3,

  /**
   * @generated from enum value: TAC_STATUS_DECLINED = 4;
   */
  TAC_STATUS_DECLINED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(ConversationTacStatus)
proto3.util.setEnumType(ConversationTacStatus, "qliq_protobuf.ConversationTacStatus", [
  { no: 0, name: "TAC_STATUS_UNDEFINED" },
  { no: 1, name: "TAC_STATUS_PRESENTED" },
  { no: 2, name: "TAC_STATUS_NOT_APPLICABLE" },
  { no: 3, name: "TAC_STATUS_ACCEPTED" },
  { no: 4, name: "TAC_STATUS_DECLINED" },
]);

